function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", null);

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  version: 1.1,
  id: "Layer_1",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 512 512",
  style: {
    "enableBackground": "new 0 0 512 512"
  },
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("polygon", {
  style: {
    "fill": "#92949B"
  },
  points: "361.443,306.028 360.415,364.784 319.983,347.489 319.983,347.478 307.921,335.417  307.91,335.417 259.108,286.614 168.101,195.607 167.744,195.24 179.302,183.671 209.194,153.78 220.721,165.317 220.731,165.317  254.923,199.519 260.23,204.826 300.569,245.165 328.342,272.938 361.432,306.018 "
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#E8B33F"
  },
  d: "M500,487.371c-15.313,14.6-39.688,13.792-54.655-1.164l-15.093-15.103l-20.033-20.022l-92.255-92.266 c-2.57-2.57-2.57-6.744,0-9.314l2.014-2.014l15.093-15.093l26.368-26.368l2.014-2.014c2.58-2.58,6.744-2.58,9.314,0l127.905,127.895 C515.995,447.232,515.775,472.32,500,487.371z"
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    "fill": "#66686D"
  },
  points: "319.983,347.489 319.983,347.478 307.921,335.417 307.91,335.417 259.108,286.614  168.101,195.607 167.744,195.24 179.302,183.671 190.829,195.209 190.84,195.209 225.032,229.411 230.339,234.718 270.677,275.056  298.45,302.829 331.541,335.91 331.551,335.92 "
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#484B54"
  },
  d: "M182.554,56.584c31.898-31.898,82.404-41.02,123.743-16.738 c-37.898,16.82-80.646,55.741-96.384,82.96l-44.11,1.324l-2.658-48.136l0.015-0.015C173.906,65.231,181.716,57.422,182.554,56.584z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#D39F37"
  },
  d: "M500,487.371c-15.313,14.6-39.688,13.792-54.655-1.164l-15.093-15.103l-20.033-20.022l-92.255-92.266 c-2.57-2.57-2.57-6.744,0-9.314l2.014-2.014v-0.01l15.093-15.082C335.071,332.395,397.97,424.095,500,487.371z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#484B54"
  },
  d: "M76.017,133.514l58.318,21.028l18.404,55.694l0,0c-7.999-5.661-18.501-6.699-27.281-2.347 c-3.266,1.619-6.408,3.85-9.229,6.671c-2.765,2.765-4.962,5.838-6.572,9.035c-4.434,8.805-3.393,19.389,2.256,27.469l0,0 l-56.762-12.088l-19.96-64.634l0,0c8.565,5.919,19.815,6.697,28.887,1.591c2.708-1.524,5.305-3.477,7.675-5.848 c2.827-2.827,5.062-5.977,6.682-9.254C82.789,152.029,81.722,141.505,76.017,133.514L76.017,133.514z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#92949B"
  },
  d: "M111.913,251.063l-35.19,35.19L0,209.531l35.19-35.19C35.19,174.341,110.504,249.609,111.913,251.063 z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#66686D"
  },
  d: "M97.808,236.958l13.239,13.239c0,0,0.607,0.563,0.865,0.865l-35.19,35.19l-15.021-15.021 l35.19-35.19C97.205,236.325,97.808,236.958,97.808,236.958z"
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    "fill": "#66686D"
  },
  points: "220.721,165.317 179.271,206.767 179.271,206.777 168.101,195.607 167.744,195.24  209.194,153.78 \t"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#92949B"
  },
  d: "M208.929,360.905l191.103-191.103c10.91-10.91,24.438-18.699,39.156-23.33 c10.307-3.243,20.007-8.946,28.177-17.116c27.656-27.656,27.105-72.82-1.627-99.794l-13.111,42.03 c-5.051,16.192-22.272,25.223-38.464,20.171l0,0c-16.192-5.051-25.223-22.272-20.172-38.464l12.961-41.55 c-12.471,2.033-24.479,7.433-34.478,16.224c-21,18.465-28.036,46.283-21.118,71.022c5.19,18.56,0.351,38.471-13.276,52.099 L146.976,342.197c-10.91,10.91-24.438,18.699-39.156,23.33c-10.307,3.243-20.007,8.945-28.177,17.116 c-27.656,27.656-27.105,72.82,1.627,99.794l13.111-42.03c5.051-16.192,22.272-25.223,38.464-20.171l0,0 c16.192,5.051,25.223,22.272,20.172,38.464l-12.962,41.55c12.471-2.033,24.479-7.433,34.478-16.224 c21-18.464,28.036-46.282,21.118-71.021C190.463,394.443,195.301,374.532,208.929,360.905z"
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    "fill": "#66686D"
  },
  points: "300.569,245.165 259.108,286.614 218.781,246.287 260.23,204.826 "
}), /*#__PURE__*/React.createElement("rect", {
  x: 153.655,
  y: 227.48,
  transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 647.9 243.6259)",
  style: {
    "fill": "#EA3D3D"
  },
  width: 239.677,
  height: 57.035
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#92949B"
  },
  d: "M148.358,61.175l14.789,14.818l31.964,32.009l14.803,14.803l15.129,15.129l-15.849,15.849 l-0.007-0.007l-41.457,41.457l0.007,0.007l-14.996,14.996c-1.417-1.372-75.343-75.314-76.722-76.722 C76.017,133.514,121.406,88.126,148.358,61.175z"
}), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);

export default __webpack_public_path__ + "static/media/tools.370617bc.svg";
export { SvgComponent as ReactComponent };